export { default } from "./ListItemHeaderCategoryHeading";
